export enum ErrorCodes {
  // USER ERROR CODES
  USER_ERR_APARTMENT_DOES_NOT_BELONG_TO_USER = `L'appartamento non è dell'utente specificato`,
  USER_ERR_BUILDING_DOES_NOT_BELONG_TO_USER = `Il palazzo specificato non è collegato all'utente`,
  USER_ERR_INVALID_CREDENTIALS = `Credenziali errate`,
  USER_ERR_INVALID_PERMISSIONS = `Autorizzazione negata`,
  USER_ERR_INVALID_PHONE_NUMBER = "Numero di telefono non valido",
  USER_ERR_INVALID_TOKEN = "Token non valido",
  USER_ERR_VALIDATION_REQUIRED_FIELD = "Non sono specificati tutti i campi obbligatori",
  USER_ERR_MISSING_REQUIRED_PARAM = "Parametro obbligatorio non specificato",
  USER_ERR_NOT_FOUND = "Utente non trovato",
  USER_PENDING_OR_BLOCKED = "Utente bloccato oppure in attesa di attivazione",
  USER_ERR_ACTIVE = `L'utente è già attivo`,
  USER_ERR_USERNAME_ALREADY_TAKEN = "Nome utente già utilizzato",
  USER_ERR_PHONE_ALREADY_TAKEN = "Numero di telefono già utilizzato",
  USER_ERR_BLOCKED = "Utente bloccato",
  USER_ERR_WRONG_PASSWORD = "Password errata",
  // APARTMENT ERROR CODES
  APARTMENT_ERR_CODE_EXISTS_ALREADY = `Codice appartamento già utilizzato`,
  APARTMENT_ERR_INVALID_PERMISSIONS = "Autorizzazione negata",
  APARTMENT_ERR_MISSING_REQUIRED_PARAM = "Parametro obbligatorio mancante",
  APARTMENT_ERR_VALIDATION_REQUIRED_FIELD = "Campo obbligatorio non specificato",
  APARTMENT_ERR_NOT_FOUND = "Appartamento non trovato",
  APARTMENT_ERR_TOO_MANY_USERS = "Limite massimo utenti per appartamento superato",
  APARTMENT_ERR_USER_ALREADY_IN_APARTMENT = `L'utente è già nell'appartamento`,
  APARTMENT_ERR_USER_NOT_IN_APARTMENT = `L'utente non fa parte dell'appartamento`,
  APARTMENT_ERR_USER_EXISTS_ALREADY_TRY_INVITE = `L'utente esiste già, tentare la funzione 'invita' al posto di 'crea'`,
  // BUILDING ERROR CODES
  BUILDING_ERR_INVALID_PERMISSIONS = "Autorizzazione negata",
  BUILDING_ERR_MISSING_REQUIRED_PARA = "Parametro obbligatorio mancante",
  BUILDING_ERR_VALIDATION_REQUIRED_FIELD = "Campo obbligatorio non specificato",
  BUILDING_ERR_NOT_FOUND = "Palazzo non trovato",
  // COUPONS ERROR CODES
  COUPON_CANNOT_BE_DELETED_BECAUSE_USED_ALREADY = "Il coupon non può essere eliminato perché è già stato utilizzato da qualcuno almeno una volta.",
  // AMENITY ERROR CODES
  ERR_APARTMENT_MAX_UNITS_NOT_SET = `Impossibile prenotare per l'appartamento in oggetto in quanto non è ancora stato indicato il numero massimo di unità prenotabili in base ai millesimi.`,
  ERR_MODEL_VALIDATION = "Non tutti i campi obbligatori sono stati compilati",
  ERR_INVALID_BUILDING = "Il palazzo specificato non è stato trovato",
  ERR_INVALID_AMENITY = `L'amenity specificata non è stata trovata`,
  ERR_SERVICE_DEFINITION_ALREADY_EXISTS_IN_PERIOD = `Si sta cercando di definire un periodo di esercizio a cavallo di un periodo esistente.`,
  ERR_ESCLUSIVE_RESERVATION_NOT_SUPPORTED_BY_SERVICE = `Il servizio in oggetto non gestisce la prenotazione esclusiva`,
  ERR_INVALID_SLOTS_AMOUNT = `Numero di slots selezionati non valido`,
  ERR_UNAUTHORIZED = `Autorizzazione Negata`,
  ERR_USER_NOT_OWNING_APARTMENT = `L'utente non è proprietario dell'appartamento`,
  ERR_MISSING_PARAMS = `Non sono stati passati i parametri fondamentali per la ricerca`,
  ERR_NO_AMENITY_SPECIFIED = `Specificare un'amenity`,
  ERR_MISSING_PARAM_FROM = `Specificare il campo 'dal'`,
  ERR_MISSING_PARAM_TO = `Specificare il campo 'al'`,
  ERR_INVALID_DATE_RANGE = `Il range di date specificato non è valido`,
  ERR_SERVICE_DEFINITION_NOT_FOUND = `Servizio non trovato`,
  ERR_SLOT_RESERVED_ALREADY = `Almeno uno slot è già stato prenotato per questo appartamento nell'orario indicato.`,
  ERR_NOT_FOUND = `Non trovato`,
  ERR_TOO_MANY_UNITS_FOR_APARTMENT = `Il limite massimo di ospiti per il tuo appartamento non consente la prenotazione`,
  ERR_TOO_MANY_ACTIVE_RESERVATIONS = `L'appartamento ha troppe prenotazioni attive per il servizio indicato.`,
  ERR_NOT_ENOUGH_FREE_UNITS_IN_SLOT = "Non ci sono posti liberi sufficienti per lo slot / gli slots selezionati.",
  // COMMUNICATIONS ERROR CODES
  ERR_COMMUNICATION_NOT_IN_DRAFT_MODE = "La comunicazione non si trova più in stato bozza, di conseguenza non è possibile modificarla.",
  ERR_APARTMENT_BLOCKED_FROM_RESERVING = "L'appartamento è stato bloccato in quanto non si è presentato a 3 o più prenotazioni di amenities. Puoi sbloccarlo nella sezione Appartamenti",
  // EXTERNAL SERVICES ERROR CODES
  SERVICE_ERR_CANNOT_DELETE_BECAUSE_PAID_ALREADY = "La prenotazione è già stata pagata dal cliente, di conseguenza non può essere annullata.",
  SERVICE_ERR_BUILDING_NOT_SPECIFIED = "Palazzo non specificato",
  SERVICE_ERR_MISSING_APARTMENT_CONTEXT = "Appartamento non specificato",
  SERVICE_ERR_MISSING_BUILDING_CONTEXT = "Palazzo non specificato",
  // GENERIC ERROR CODES
  ERR_MISSING_BUILDING_CONTEXT = "Alcune informazioni non possono essere visualizzate perché variano in base al palazzo che le richiede. Specificare il palazzo.",
  ERR_MISSING_REQUIRED_FIELD = "Non tutti i campi obbligatori sono stati compilati. Per favore, controlla che tutti i campi con * siano stati compilati. Se sono dei campi in lingua, controlla che almeno una lingua sia stata inserita.",
}

export function getErrorMessage(errorCode: string): string {
  return ErrorCodes[errorCode];
}
